import React from "react";
import styles from "./styles.module.scss";
import formatNumber from "../../utils/formatNumber";

function Legend({ title, items, className }) {
    const formatValue = (value) => {
        if (value < 1) {
            // return percentage
            return `${(value * 100).toFixed(1)}%`;
        }

        let val = parseFloat(value).toFixed(1);

        return formatNumber(val);
    };
    
    return (
        <div className={`${styles.chartInfo} ${className} chart-legend`}>
            {title && <h5>{title}</h5>}
            <div className={`${styles.legends} chart-legend__legends`}>
                {items.map((item) => (
                    <div key={item.name} className={`${styles.legendItem} chart-legend__legend-item`}>
                        <div style={{ backgroundColor: item.color }}></div>
                        <span>
                            {item.name}{" "}
                            {item.value && (
                                <small>({formatValue(item.value)})</small>
                            )}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Legend;